import { CardCvcElement, CardExpiryElement, CardNumberElement } from '@stripe/react-stripe-js';
import { TextField } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import { StripeElementChangeEvent } from '@stripe/stripe-js';
import clsx from 'clsx';
import StripeInput from './StripeInput';
import useStyles from './styles';

type ComponentType = 'card' | 'expiration_date' | 'cvc';
type Props = {
  name: string;
  label: string;
  componentType: ComponentType;
  setValidStatus?: (bool: boolean) => void;
};

const StripeField = ({
  name,
  label, componentType,
  setValidStatus,
}: Props) => {
  const classes = useStyles();
  const [focus, setFocus] = useState(false);
  const [stripeInputState, setStripeInputState] = useState<StripeElementChangeEvent | null>(null);
  const [valid, setValid] = useState(true);
  const [touched, setTouched] = useState(false);
  const errorStatus = !valid || (stripeInputState && stripeInputState.empty) || (!stripeInputState && touched);

  useEffect(() => {
    if (stripeInputState) {
      setValid(!stripeInputState.error);
      if (setValidStatus) {
        setValidStatus(stripeInputState.complete);
      }
    }
  }, [stripeInputState, setValidStatus, setValid]);

  const getComponentByType = useCallback(() => {
    switch (componentType) {
      case 'card':
        return CardNumberElement;
      case 'expiration_date':
        return CardExpiryElement;
      case 'cvc':
        return CardCvcElement;
      default:
        return null;
    }
  }, [componentType]);

  return (
    <TextField
      fullWidth
      InputLabelProps={{
        shrink: (stripeInputState && !stripeInputState.empty) || focus,
        className: clsx(classes.labelRoot, {
          [classes.labelRootError]: errorStatus,
        }),
      }}
      classes={{
        root: classes.input,
      }}
      className={clsx({
        [classes.error]: errorStatus,
      })}
      // @ts-ignore
      InputProps={{
        inputComponent: StripeInput,
        inputProps: {
          component: getComponentByType(),
          updateStripeInputState: setStripeInputState,
          textColor: errorStatus ? '#F8221A' : '#263245',
        },
      }}
      label={label}
      name={name}
      onFocus={() => { setFocus(true); }}
      onBlur={() => { setFocus(false); setTouched(true); }}
    />
  );
};


export default StripeField;
